import {HiOutlineMail} from 'react-icons/hi'
import {FaWhatsapp} from 'react-icons/fa'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:pattyxica24@gmail.com'},
    {id: 3, icon: <FaWhatsapp/>, link: 'https://api.whatsapp.com/send?phone=5561998092741&text=Ol%C3%A1%2C%20vim%20do%20site%20pattyweb.com.br'}
]


// alternative whatsApp link
// https://wa.me/yournumber
// https://api.whatsapp.com/send/?phone=%2B233557097546


export default data